<template src='./pif1-5-3.html'></template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import { JSONEditor } from '@json-editor/json-editor/'
import SimpleMDE from 'simplemde/dist/simplemde.min.js'
import { hasAdminClaim, hasProjectManageClaim, hasProjectEvaluateClaim, authorizedOrganizationId } from '@/router/auth'

// const DISPLAY = 'display'

export default {
  components: {
    ContextPage,
    SimpleMDE
  },
  data () {
    return {
      obj: {},
      markFields: 18,
      jsonDialog: false,
      jsonScheme: null,
      showErrorPanel: false,
      validationErrors: [],
      autoCompleteUrl_budgetId: Vue.$apiConfig.budgetUsersGet,
      resultContent: null,
      initialSchema: {},
      initialEditor: {},
      initialConfig: {},
      initialVal: {},
      initialMarks: {},
      pif: null,
      errorPanel: null,
      editor: null,
      projectCode: this.$route.params.projectCode,
      projectPhaseId: this.$route.params.projectPhaseId,
      phaseFormId: this.$route.params.phaseFormId,
      formId: null,
      formStatus: 0,
      evaluator: '',
      project: {},
      projectForm: null,
      loading: false,
      ProjectStatus: {
        DRAFT: 1,
        CREATED: 2,
        ACCEPTED: 3
      },
      FormInputAction: {
        SAVE: 1,
        LOCKSAVE: 2,
        UNLOCKSAVE: 3,
        MARK: 4,
        LOCKMARK: 5,
        UNLOCKMARK: 6
      },
      FormInputStatus: {
        UNLOCKED: 1,
        LOCKED: 2,
        MARKED: 3,
        APPROVED: 4
      },
      status: [
        {
          color: 'pending',
          text: this.$t('projects.formStatuses.1')
        },
        {
          color: 'active-light',
          text: this.$t('projects.formStatuses.2')
        },
        {
          color: 'active-light',
          text: this.$t('projects.formStatuses.3')
        },
        {
          color: 'success',
          text: this.$t('projects.formStatuses.4')
        }
      ],
      markdownFields: [
        { name: 'root.1.comment', element: 'root[1][comment]', field: '1.comment', index: 1 },
        { name: 'root.2.comment', element: 'root[2][comment]', field: '2.comment', index: 2 },
        { name: 'root.3.comment', element: 'root[3][comment]', field: '3.comment', index: 3 },
        { name: 'root.4.comment', element: 'root[4][comment]', field: '4.comment', index: 4 },
        { name: 'root.5.comment', element: 'root[5][comment]', field: '5.comment', index: 5 },
        { name: 'root.6.comment', element: 'root[6][comment]', field: '6.comment', index: 6 },
        { name: 'root.7.comment', element: 'root[7][comment]', field: '7.comment', index: 7 },
        { name: 'root.8.comment', element: 'root[8][comment]', field: '8.comment', index: 8 },
        { name: 'root.9.comment', element: 'root[9][comment]', field: '9.comment', index: 9 },
        { name: 'root.10.comment', element: 'root[10][comment]', field: '10.comment', index: 10 },
        { name: 'root.11.comment', element: 'root[11][comment]', field: '11.comment', index: 11 },
        { name: 'root.12.comment', element: 'root[12][comment]', field: '12.comment', index: 12 },
        { name: 'root.13.comment', element: 'root[13][comment]', field: '13.comment', index: 13 },
        { name: 'root.14.comment', element: 'root[14][comment]', field: '14.comment', index: 14 },
        { name: 'root.15.comment', element: 'root[15][comment]', field: '15.comment', index: 15 },
        { name: 'root.15.input.activity.comment', element: 'root[15][input][activity][comment]', field: '15.input.activity.comment', index: 15 },
        { name: 'root.15.input.outcomes.comment', element: 'root[15][input][outcomes][comment]', field: '15.input.outcomes.comment', index: 15 },
        { name: 'root.15.input.results.comment', element: 'root[15][input][results][comment]', field: '15.input.results.comment', index: 15 },
        { name: 'root.16.comment', element: 'root[16][comment]', field: '16.comment', index: 16 },
        { name: 'root.17.comment', element: 'root[17][comment]', field: '17.comment', index: 17 },
        { name: 'root.18.comment', element: 'root[18][comment]', field: '18.comment', index: 18 },
        { name: 'root.18.input.negative influence.comment', element: 'root[18][input][negative influence][comment]', field: '18.input.negative influence.comment', index: 18 },
        { name: 'root.18.input.positive influence.comment', element: 'root[18][input][positive influence][comment]', field: '18.input.positive influence.comment', index: 18 }
      ]
    }
  },
  computed: {
    isAdmin () {
      return hasAdminClaim()
    },
    canManageProject () {
      return hasProjectManageClaim()
    },
    userOrganizationId () {
      return authorizedOrganizationId()
    },
    canEditProject () {
      return this.formStatus === this.FormInputStatus.UNLOCKED && hasProjectManageClaim() && this.userOrganizationId === this.project.organizationId && Number(this.projectPhaseId) === this.project.projectPhaseId
    },
    canUnlockProject () {
      return this.formStatus === this.FormInputStatus.LOCKED && hasProjectManageClaim() && this.userOrganizationId === this.project.organizationId && Number(this.projectPhaseId) === this.project.projectPhaseId
    },
    canEvaluateProject () {
      return this.formStatus === this.FormInputStatus.LOCKED && hasProjectEvaluateClaim() && this.userOrganizationId === this.evaluator && Number(this.projectPhaseId) === this.project.projectPhaseId
    }
  },
  methods: {
    validateFormInput () {
      const errors = this.editor.validate()
      if (errors && errors.length > 0) {
        this.validationErrors = errors
        this.showErrorPanel = true
        this.$nextTick(function () {
          this.scrollToErrorPanel()
        })
      }
      return errors && errors.length > 0
    },
    submitFormInput (action) {
      // if (this.validateFormInput()) { return }
      this.loading = true
      const values = this.editor.getValue()
      console.log(values)
      for (var i = 0; i < this.markdownFields.length; i++) {
        const markName = 'mark'
        this.set(values, this.markdownFields[i].field, this.editor.getEditor(this.markdownFields[i].name).simplemde_instance.value())
        // values[this.markdownFields[i].index][this.markdownFields[i].field] = this.editor.getEditor(this.markdownFields[i].name).simplemde_instance.value()
        delete values[this.markdownFields[i].index][markName]
      }
      console.log(values)
      this.projectForm = {
        projectCode: this.projectCode,
        projectPhaseId: this.projectPhaseId,
        id: this.phaseFormId,
        formId: this.formId,
        json: JSON.stringify(values),
        action: action
      }
      this.$http.post(Vue.$apiConfig.projectInputFormPost, this.projectForm)
        .then(
          response => {
            this.logConsole(response)
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('projects.submitProjectFormInputSuccessful'),
              errors: []
            })
            this.setupPage()
            this.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.loading = false
          }
        )
    },
    markFormInput (action) {
      this.loading = true
      const markeditors = {}
      for (let i = 0; i < this.markFields; i++) {
        markeditors[(i + 1) + '.mark'] = this.editor.getEditor('root.' + (i + 1) + '.mark').getValue()
      }
      this.projectForm = {
        projectCode: this.projectCode,
        formId: this.formId,
        json: JSON.stringify(markeditors),
        action: action
      }
      this.$http.post(Vue.$apiConfig.projectInputFormPost, this.projectForm)
        .then(
          response => {
            this.logConsole(response)
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('projects.markProjectFormInputSuccessful'),
              errors: []
            })
            this.setupPage()
            this.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.loading = false
          }
        )
    },
    fetch (query) {
      const queryParamName = 'search'
      const url = this.autoCompleteUrl_budgetId
      const params = Object.assign({ [queryParamName]: query })
      const cancel = new Promise((resolve) => (this.cancel = resolve))
      const request = this.$http.get(url, { params })

      return Promise.race([cancel, request])
    },
    cancel () {
      // used to 'cancel' previous searches
    },
    setupPage () {
      this.loading = true
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + this.phaseFormId)
        .then(
          response => {
            this.logConsole(response)
            const payload = response.data.payload
            const formInput = payload.projectFormInput
            this.formStatus = formInput.status
            this.evaluator = payload.projectForm.evaluator
            this.formId = payload.projectForm.id
            this.pif = JSON.parse(payload.projectForm.json)
            this.initialSchema = this.pif.schema
            this.initialConfig = this.pif.config
            this.initialVal = formInput.inputJson ? JSON.parse(formInput.inputJson) : null
            this.initialMarks = formInput.markJson ? JSON.parse(formInput.markJson) : null
            this.initializeEditor()
            this.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.loading = false
          }
        )
    },
    initializeEditor () {
      const el = document.getElementById('editorHolder')
      this.initialConfig.schema = this.initialSchema
      this.initialConfig.no_additional_properties = true
      this.initialConfig.schema.definitions.question.properties.mark.options.hidden = (this.formStatus !== this.FormInputStatus.LOCKED || this.formStatus !== this.FormInputStatus.MARKED)
      if (this.canEvaluateProject) {
        this.initialConfig.disable_array_add = true
        this.initialConfig.disable_array_delete = true
        this.initialConfig.disable_array_delete_all_rows = true
        this.initialConfig.disable_array_delete_last_row = true
        this.initialConfig.disable_array_reorder = true
      }
      if (this.editor) { this.editor.destroy() }
      this.editor = new JSONEditor(el, this.initialConfig)
      this.resultContent = this.initialEditor

      this.editor.on('ready', () => {
        for (var j = 0; j < this.markdownFields.length; j++) {
          this.editor.getEditor(this.markdownFields[j].name).simplemde_instance.toTextArea()
          this.editor.getEditor(this.markdownFields[j].name).simplemde_instance = null
          const config = {
            element: document.getElementsByName(this.markdownFields[j].element)[0],
            spellChecker: false,
            hideIcons: ['heading'],
            autosave: { enabled: true },
            showIcons: this.canEditProject ? ['heading-2', 'heading-3', 'horizontal-rule', 'code', 'table'] : false,
            status: ['autosave', 'lines', 'words', 'cursor']
          }
          if (!this.canEditProject) { config.toolbar = false }
          this.editor.getEditor(this.markdownFields[j].name).simplemde_instance = new SimpleMDE(config)
        }
        if (this.initialVal) {
          if (this.initialMarks) { Object.assign(this.initialVal, this.initialMarks) }
          this.saveJsonValues(this.initialVal)
        }
        this.manageInput()
      })
      console.log(this.editor)
    },
    manageInput () {
      if (this.isAdmin) { return }
      if (this.canEditProject) {
        for (var i = 0; i < this.markFields; i++) { this.editor.getEditor('root.' + (i + 1) + '.mark').disable() }
      } else if (this.canEvaluateProject) {
        this.editor.disable()
        for (var j = 0; j < this.markdownFields.length; j++) { this.editor.getEditor(this.markdownFields[j].name).simplemde_instance.togglePreview() }
        for (var k = 0; k < this.markFields; k++) { this.editor.getEditor('root.' + (k + 1) + '.mark').enable() }
      } else {
        this.editor.disable()
        for (j = 0; j < this.markdownFields.length; j++) { this.editor.getEditor(this.markdownFields[j].name).simplemde_instance.togglePreview() }
        for (i = 0; i < this.markFields; i++) { this.editor.getEditor('root.' + (i + 1) + '.mark').disable() }
      }
    },
    openJsonDialog () {
      this.jsonScheme = JSON.stringify(this.editor.getValue(), null, 2)
      this.jsonDialog = true
    },
    closeJsonDialog () {
      this.saveJsonValues(JSON.parse(this.jsonScheme))
      this.jsonDialog = false
    },
    saveJsonValues (jsonScheme) {
      const markName = 'mark'
      const markComment = 'comment'
      for (var i = 0; i < this.markFields; i++) {
        if (jsonScheme[i + 1] && !jsonScheme[i + 1][markName]) {
          jsonScheme[i + 1][markName] = {}
          jsonScheme[i + 1][markName][markComment] = ''
        }
      }
      for (const key in jsonScheme) {
        var property = this.editor.getEditor('root.' + key)
        if (property) {
          property.setValue('')
          property.setValue(jsonScheme[key])
        }
      }
    },
    extractErrorItem (message) {
      var regExp = /'[0-9]+'/
      return regExp.exec(message)[0]
    },
    scrollToErrorPanel () {
      const element = this.$refs.errorPanel
      var top = element.offsetTop

      window.scrollTo(0, top)
    },
    set (obj, path, value) {
      var schema = obj
      var pList = path.split('.')
      var len = pList.length
      for (var i = 0; i < len - 1; i++) {
        var elem = pList[i]
        if (!schema[elem]) { schema[elem] = {} }
        schema = schema[elem]
      }
      schema[pList[len - 1]] = value
    }
  },
  created () {
    this.setupPage()
  }
}
</script>

<style>
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}

.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}

.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}
.autocomplete-result {
  background-image: none !important;
  padding-left: 10px !important;
}
.hidden-panel {
  display: none !important;
}
</style>
